import ReportingClient from "@hypexone/uicore/lib/cjs/src/client/reporting/reporting_client";
import { getBaseUrl, getEnvUrlsMap } from "./api/api-services/environment-url/environment-url";
import CommonClient from "@hypexone/uicore/lib/cjs/src/client/reddog/common_client";
import AccountClient from "@hypexone/uicore/lib/cjs/src/client/reddog/account_client";
import {
  AppDispatch,
  createApiClient,
  createAppStore,
  getAccessTokenWithRefreshToken,
  logout,
} from "@hypexone/uicore";
import PaymentClient from "@hypexone/uicore/lib/cjs/src/client/payment/payment_client";
import axios from "axios";

import { CURRENT_SKIN_LABEL } from "./constants/Branding";

// Define environment-specific variables
const API = getBaseUrl(import.meta.env.VITE_NODE_ENV, "REACT_APP_REST_API_URL");
const SVLS_API = getBaseUrl(
  import.meta.env.VITE_NODE_ENV,
  "REACT_APP_REST_API_V2_URL"
);

const LANG_API = getBaseUrl(
  import.meta.env.VITE_NODE_ENV,
  "REACT_APP_LANG_URL"
);

const REPORTING_API = getBaseUrl(
  import.meta.env.VITE_NODE_ENV,
  "REACT_APP_REST_REPORTING_API_URL"
);
const AGPAY_API = getBaseUrl(
  import.meta.env.VITE_NODE_ENV,
  "REACT_APP_REST_AGPAY_URL"
);

const CATALOG_API = getBaseUrl(
  import.meta.env.VITE_NODE_ENV,
  "REACT_APP_REST_CATALOG_URL"
)

const API_SPORT_FEED = getBaseUrl(
  import.meta.env.VITE_NODE_ENV,
  "REACT_APP_SPORT_FEED_URL"
);

// Error handler function
export const errorHandler = (error: any) => {
  if (error.response && error.response.status === 401) {
    const token = sessionStorage.getItem("jwt_token");
    if (token) {
      const dispatch = store.dispatch as AppDispatch;
      if(error.config.url == '/account/v2/access-token'){
        dispatch(logout());
      } else {
        dispatch(getAccessTokenWithRefreshToken());
      }
    }
  }
};

export const commonClient = new CommonClient(
  SVLS_API,
  sessionStorage.getItem("jwt_token"),
  errorHandler
);

export const accountClient = new AccountClient(
  getEnvUrlsMap(import.meta.env.VITE_NODE_ENV),
  sessionStorage.getItem("jwt_token"),
  errorHandler
);

export const catalogClient = new CommonClient(
  CATALOG_API,
  sessionStorage.getItem("jwt_token"),
  errorHandler
);

export const paymentClient = new PaymentClient(
  AGPAY_API,
    sessionStorage.getItem("jwt_token"),
    errorHandler
  );

  
export const ReportsClient = new ReportingClient(
  getEnvUrlsMap(import.meta.env.VITE_NODE_ENV),
  sessionStorage.getItem("jwt_token"),
  errorHandler
);

export const LANG_API_CLIENT = axios.create({
  baseURL: LANG_API,
  responseType: "json",
  timeout: 1000 * 20,
});
// Create the API client using environment variables
export const API_CLIENT = createApiClient(
  API,
  sessionStorage.getItem("jwt_token"),
  errorHandler
);
export const SVLS_API_CLIENT = createApiClient(
  SVLS_API,
  sessionStorage.getItem("jwt_token"),
  errorHandler
);

// The login thunks in @hypexone/uicore build the login body themselves, so the skin label is added
// here. reddog uses it to record skin metrics.
SVLS_API_CLIENT.interceptors.request.use((config) => {
  const isLogin = config.url?.replace(/^\//, "") === "account/v2/login";
  if (
    isLogin &&
    config.method === "post" &&
    CURRENT_SKIN_LABEL &&
    config.data &&
    typeof config.data === "object"
  ) {
    config.data = { ...config.data, skin: CURRENT_SKIN_LABEL.toUpperCase() };
  }
  return config;
});

export const REPORTING_API_CLIENT = createApiClient(
  REPORTING_API,
  sessionStorage.getItem("jwt_token"),
  errorHandler
);
export const AGPAY_API_CLIENT = createApiClient(
  AGPAY_API,
  sessionStorage.getItem("jwt_token"),
  errorHandler
);
export const API_SPORT_FEED_CLIENT = createApiClient(
  API_SPORT_FEED,
  sessionStorage.getItem("jwt_token"),
  errorHandler
);

export const CATALOG_API_CLIENT = createApiClient(
  CATALOG_API,
  sessionStorage.getItem("jwt_token"),
  errorHandler
);

export const store = createAppStore({
  API_CLIENT,
  SVLS_API_CLIENT,
  REPORTING_API_CLIENT,
  AGPAY_API_CLIENT,
  API_SPORT_FEED_CLIENT,
  LANG_API_CLIENT,
  CATALOG_API_CLIENT
});
